import { Component } from '@angular/core';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-enrolled',
  templateUrl: './enrolled.component.html'
})
export class EnrolledComponent {

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private appService: AppService) { }

  //-- EVENTS ----------------------------------------------------------|

  onBack() {
    this.appService.redirectTo(this.appService._REGISTER);
    return false;
  }

  //--------------------------------------------------------------------|
  
}